import { PublicationsPageConfigService } from './shared/publications-page.config.service';
import { PublicationsPageDataService } from './shared/publications-page.data.service';
import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import 'rxjs/add/operator/finally';
import { Logger } from '../core';
import { TreeviewConfig, TreeviewItem, TreeviewSelection } from 'ngx-treeview';
import { Publicacion } from '../shared/models/publicacion.model';
import { environment } from '@env/environment';

const log = new Logger('Login');

@Component({
  selector: 'iw-publications-page',
  templateUrl: './publications-page.component.html',
  styleUrls: ['./publications-page.component.scss'],
  providers: [PublicationsPageDataService]
})
export class PublicationsPageComponent implements OnInit {
  constructor(
    private ppds: PublicationsPageDataService
  ) { }
  // Datos para llenar la tabla
  sourceData: Publicacion[] = [];
  // configuraciones de la tabla
  settings = {};
  // define el tipo de boton a mostrar en el dropdown
  btnClass = 'btn-outline-light';
  // habilita o inhabilita el dropdown
  dropdownEnabled = true;
  // contiene el arbol de boletines
  items: TreeviewItem[];
  // configuracion del compinente treeview
  config = {
    hasAllCheckBox: false
  };
  // Atajo a las configuraciones del entorno de ejecución
  env = environment;

  private internalSelectedItem: TreeviewItem;

  ngOnInit(): void {
    this.getBulletins();
    const configTable = new PublicationsPageConfigService();
    this.settings = configTable.settings;
    configTable.accion.subscribe((res: any) => {
      switch (res.action) {
        case 'descargar':
          this.downloadDocument(res.data);
          break;
      }
    });
  }
  getBulletins() {
    this.items = this.ppds.getProcessBolletins();
  }

  onSelectedChange(e: any) {
    if (e.length > 0) {
      this.ppds.getPublicaciones(e[0].value).subscribe(res => {
        res.forEach(e => {
          e.estado = 'Notificado';
        });
        this.sourceData = res;
      });
    }
  }

  select(item: TreeviewItem): void {
    if (!item.children) {
      this.selectItem(item);
    }
  }
  private selectItem(item: TreeviewItem): void {
    if (this.selectedItem !== item) {
      this.selectedItem = item;
      this.onSelectedChange([item]);
    }
  }

  set selectedItem(value: TreeviewItem) {
    this.internalSelectedItem = value;
  }

  get selectedItem(): TreeviewItem {
    return this.internalSelectedItem;
  }

  getText(selection: TreeviewSelection): string {
    return this.internalSelectedItem ? this.internalSelectedItem.text : 'Please select';
  }


  /**
   * Valida el documento y emite la acción de descargar el documento
   *
   * @private
   * @param {number} data
   * @return {*}  {*}
   * @memberof PublicationsComponent
   */
  private downloadDocument(data: any): any {
    this.ppds.dowloadFilePublicaction(data.id).subscribe((res: any) => {
      const a = document.createElement('a');
      a.target = '_blank';
      a.href = res.file.path;
      a.download = res.file.name;
      a.click();
      a.remove();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/publications-page/publications-page.component.ts